/**
 * The Fernly look off the CEO's portal (owner, 27 Oct 2026: "major ui upgrade"
 * of the merged Enquiries & meetings desk and the office's field pages).
 *
 * The tokens (tokens.css) answer to `data-look="fernly"` on <html>, as the
 * CEO's portal answers to `data-portal="ceo"`: on the root, so drawers and
 * popovers portalled to <body> wear it too, and the rail and the top bar with
 * it. The frame sets it for the routes below, before paint, and takes it off
 * when it leaves them — kept by the frame rather than each page, so moving from
 * one of these pages to another never flashes the old look while the next one
 * loads. The pages import Plus Jakarta Sans themselves, keeping it out of the
 * entry chunk.
 */
import { useLayoutEffect } from 'react';

/** The pages that wear it: the desk, the routes that lead into it, and the office's field pages. */
export const FERNLY_PATHS = ['/enquiries', '/meetings', '/enquiry-desk', '/field-team', '/field'] as const;

export function wearsFernly(pathname: string): boolean {
  return FERNLY_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function useFernlyLook(on: boolean): void {
  useLayoutEffect(() => {
    if (!on) return;
    const root = document.documentElement;
    root.setAttribute('data-look', 'fernly');
    return () => root.removeAttribute('data-look');
  }, [on]);
}
